// frontend/src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import PricingPage from "./pages/PricingPage";
import "./styles/globals.css";

// Combined scroll handler: page top + hash with header offset
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // 1. Always scroll to top on route change (page navigation)
    window.scrollTo({
      top: 0,
      behavior: "instant", // "smooth" is okay too, but instant feels faster on page switch
    });

    // 2. Handle hash navigation (if present)
    if (hash) {
      const id = hash.replace("#", "");
      const tryScroll = (attempt = 0) => {
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 140; // ← MEASURE YOUR HEADER + safety margin (usually 100–180px)
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
          return;
        }

        // Retry up to ~1.5 seconds
        if (attempt < 5) {
          setTimeout(() => tryScroll(attempt + 1), 100 * Math.pow(1.6, attempt));
        }
      };

      // Start trying immediately
      tryScroll();
    }
  }, [pathname, hash]); // Re-run on both path AND hash change

  return null;
}

function App() {
  return (
    <Router>
      <ScrollManager />

      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          {/* <Route path="/contact" element={<ContactPage />} /> etc. */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;